// Expose initialization function globally for quick add modal
window.initializePriceTiers = function () {
  // Re-run the initialization for any new price list containers
  const priceListContainers = document.querySelectorAll(".custom-price-list");

  priceListContainers.forEach(function (priceListContainer) {
    const blockId = priceListContainer.dataset.blockId;
    const sectionId = priceListContainer.dataset.sectionId;

    if (!blockId || !sectionId) return;

    const quantityInput = document.querySelector("#Quantity-" + sectionId);
    if (!quantityInput) return;

    // Re-initialize the price tier system for this container
    const initialQuantity = parseInt(quantityInput.value) || 1;

    // Find the updateActiveTier function and call it
    const tiers = priceListContainer.querySelectorAll(".price-tier");
    let activeTier = null;

    // Get cart data for enhanced quantity calculation
    const priceListsElement = document.getElementById(
      "variant-price-lists-" + sectionId,
    );
    let totalQuantity = initialQuantity;

    if (priceListsElement) {
      try {
        const priceLists = JSON.parse(priceListsElement.textContent);
        if (priceLists.cartData) {
          const currentVariantId = priceListContainer.dataset.currentVariantId;
          const variantPriceList = priceLists.variants[currentVariantId];
          const isVariantLevelPricing =
            variantPriceList && variantPriceList.length > 0;

          if (isVariantLevelPricing) {
            const variantCartQty =
              priceLists.cartData.variantQuantities[currentVariantId] || 0;
            totalQuantity = variantCartQty + initialQuantity;
          } else {
            totalQuantity =
              priceLists.cartData.totalProductQty + initialQuantity;
          }
        }
      } catch (e) {
        console.error("Error parsing price lists data:", e);
      }
    }

    // Find the highest tier that the total quantity qualifies for
    tiers.forEach((tier) => {
      const tierElement = tier;
      const fromAmount = parseInt(tierElement.dataset.fromAmount);
      if (totalQuantity >= fromAmount) {
        activeTier = tierElement;
      }
    });

    // Update active states
    tiers.forEach((tier) => {
      tier.classList.remove("price-tier--active");
    });

    if (activeTier) {
      activeTier.classList.add("price-tier--active");
    }

    // Add event listeners for quantity changes in modal
    if (quantityInput) {
      // Remove existing listeners to avoid duplicates
      quantityInput.removeEventListener("change", quantityChangeHandler);
      quantityInput.removeEventListener("input", quantityInputHandler);

      // Define handlers
      function quantityChangeHandler() {
        const quantity = parseInt(this.value) || 1;
        updateActiveTierForModal(priceListContainer, quantity, sectionId);
      }

      function quantityInputHandler() {
        const quantity = parseInt(this.value) || 1;
        updateActiveTierForModal(priceListContainer, quantity, sectionId);
      }

      // Add event listeners
      quantityInput.addEventListener("change", quantityChangeHandler);
      quantityInput.addEventListener("input", quantityInputHandler);
    }

    // Add variant change listener for modal
    let modalVariantChangeUnsubscriber = undefined;
    if (
      typeof subscribe !== "undefined" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {
      modalVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        (event) => {
          if (event.data && event.data.variant) {
            console.log("Modal variant changed:", event.data.variant);
            updateVariantPriceForModal(priceListContainer, event.data.variant);
            updatePriceListForVariantForModal(
              priceListContainer,
              event.data.variant,
              sectionId,
            );
          }
        },
      );
    }
  });

  // Helper function to update active tier in modal
  function updateActiveTierForModal(priceListContainer, quantity, sectionId) {
    const tiers = priceListContainer.querySelectorAll(".price-tier");
    let activeTier = null;

    // Get cart data for enhanced quantity calculation (same as product page)
    const priceListsElement = document.getElementById(
      "variant-price-lists-" + sectionId,
    );
    let totalQuantity = quantity; // Default to just the input quantity

    if (priceListsElement) {
      try {
        const priceLists = JSON.parse(priceListsElement.textContent);
        if (priceLists.cartData) {
          // Determine if we're using product-level or variant-level pricing
          const currentVariantId = getCurrentVariantIdForModal();
          const variantPriceList = priceLists.variants[currentVariantId];
          const isVariantLevelPricing =
            variantPriceList && variantPriceList.length > 0;

          if (isVariantLevelPricing) {
            // Variant-level: only count this specific variant
            const variantCartQty =
              priceLists.cartData.variantQuantities[currentVariantId] || 0;
            totalQuantity = variantCartQty + quantity;
            console.log(
              "🔍 Modal - Variant-level pricing - Cart qty:",
              variantCartQty,
              "Modal qty:",
              quantity,
              "Total:",
              totalQuantity,
            );
          } else {
            // Product-level: count all variants of this product
            totalQuantity = priceLists.cartData.totalProductQty + quantity;
            console.log(
              "🔍 Modal - Product-level pricing - Cart qty:",
              priceLists.cartData.totalProductQty,
              "Modal qty:",
              quantity,
              "Total:",
              totalQuantity,
            );
          }
        }
      } catch (e) {
        console.error("❌ Error parsing price lists data in modal:", e);
      }
    }

    // Find the highest tier that the total quantity qualifies for
    tiers.forEach((tier) => {
      const fromAmount = parseInt(tier.dataset.fromAmount);
      if (totalQuantity >= fromAmount) {
        activeTier = tier;
      }
    });

    // Update active states
    tiers.forEach((tier) => {
      tier.classList.remove("price-tier--active");
    });

    if (activeTier) {
      activeTier.classList.add("price-tier--active");
      console.log(
        "✅ Modal - Active tier updated to:",
        activeTier.dataset.fromAmount,
        "for total quantity:",
        totalQuantity,
      );
    }
  }

  // Helper function to get current variant ID in modal
  function getCurrentVariantIdForModal() {
    // Try multiple selectors to find the current variant in modal
    const variantSelect = document.querySelector('select[name="id"]');
    const variantRadios = document.querySelectorAll(
      'input[name="id"][type="radio"]:checked',
    );
    const variantHidden = document.querySelector(
      'input[name="id"][type="hidden"]',
    );

    if (variantSelect) {
      return variantSelect.value;
    } else if (variantRadios.length > 0) {
      return variantRadios[0].value;
    } else if (variantHidden) {
      return variantHidden.value;
    }

    // Fallback - try to get from the price list container data
    const priceListContainer = document.querySelector(".custom-price-list");
    return priceListContainer?.dataset.currentVariantId || "";
  }

  // Helper function to update variant price in modal
  function updateVariantPriceForModal(priceListContainer, variant) {
    if (!variant || !variant.price) return;

    // Find the first price tier (Ab 1)
    const firstTier = priceListContainer.querySelector(
      '.price-tier[data-from-amount="1"]',
    );
    if (!firstTier) return;

    const priceInEuros = (variant.price / 100).toFixed(2);
    const taxMultiplier = 1.19;
    const grossPrice = (priceInEuros * taxMultiplier).toFixed(2);

    // Get the main price container
    const mainPriceElement = firstTier.querySelector(".main-price");
    if (!mainPriceElement) return;

    // Check if variant has compare_at_price and it's higher than the current price
    const hasComparePrice =
      variant.compare_at_price && variant.compare_at_price > variant.price;

    if (hasComparePrice) {
      const comparePriceInEuros = (variant.compare_at_price / 100).toFixed(2);

      // Update or create price amount container with sale and old prices
      mainPriceElement.innerHTML = `
              <div class="price-amount-container">
                <span class="price-amount price-amount-sale">${priceInEuros.replace(".", ",")} €*</span>
                <span class="price-amount price-amount--old">${comparePriceInEuros.replace(".", ",")} €*</span>
              </div>
            `;
    } else {
      // Update to simple price display
      mainPriceElement.innerHTML = `
              <span class="price-amount">${priceInEuros.replace(".", ",")} €*</span>
            `;
    }

    // Update the gross price using constant tax multiplier
    const grossPriceElement = firstTier.querySelector(".gross-price");
    if (grossPriceElement) {
      grossPriceElement.textContent =
        grossPrice.toFixed(2).replace(".", ",") + " € Brutto";
    }

    // Update the unit price in the first tier keeping Shopify's original format
    const basePriceElement = firstTier.querySelector(".base-price");
    if (basePriceElement && variant.unit_price) {
      // Get the original Shopify formatted string (e.g., "€5,18/l" or "€0,03 pro Stück")
      const priceListsElement = document.getElementById(
        "variant-price-lists-" + sectionId,
      );
      if (priceListsElement) {
        try {
          const priceLists = JSON.parse(priceListsElement.textContent);
          const originalFormat = priceLists.variantUnitMeasurements[variant.id];

          if (originalFormat) {
            // Calculate the new unit price with comma formatting
            const newUnitPrice = (variant.unit_price / 100)
              .toFixed(2)
              .replace(".", ",");
            // Replace the price part in the original format string
            const updatedFormat = originalFormat.replace(
              /€[\d,\.]+/,
              "€" + newUnitPrice,
            );
            basePriceElement.textContent = `${updatedFormat}`;
          }
        } catch (e) {
          console.error("Error parsing unit measurements:", e);
        }
      }
    }
  }

  // Helper function to update price list for variant in modal
  function updatePriceListForVariantForModal(
    priceListContainer,
    variant,
    sectionId,
  ) {
    if (!variant || !variant.id) return;

    // Get the price lists data
    const priceListsElement = document.getElementById(
      "variant-price-lists-" + sectionId,
    );
    if (!priceListsElement) return;

    try {
      const priceLists = JSON.parse(priceListsElement.textContent);

      // Get the container for the tiers (excluding the first "Ab 1" tier)
      const tiersContainer = priceListContainer.querySelector(
        ".price-list-container",
      );
      if (!tiersContainer) return;

      // Find the disclaimer button to insert tiers before it
      const disclaimerButton =
        tiersContainer.querySelector(".price-disclaimer");

      // Remove existing tiers (except the first "Ab 1" tier)
      const existingTiers = tiersContainer.querySelectorAll(
        '.price-tier:not([data-from-amount="1"])',
      );
      existingTiers.forEach((tier) => tier.remove());

      // Get the price list for this variant
      let priceListToUse = priceLists.variants[variant.id];
      if (!priceListToUse || priceListToUse.length === 0) {
        priceListToUse = priceLists.product;
      }

      // If no price list is available, just update active tier and return
      if (!priceListToUse || priceListToUse.length === 0) {
        const quantityInput = document.querySelector("#Quantity-" + sectionId);
        const currentQuantity = parseInt(quantityInput?.value) || 1;
        updateActiveTierForModal(
          priceListContainer,
          currentQuantity,
          sectionId,
        );
        return;
      }

      // Sort tiers by from_amount
      const sortedTiers = priceListToUse.sort(
        (a, b) => a.from_amount - b.from_amount,
      );

      // Add new tiers
      const variantPrice = variant.price / 100;

      sortedTiers.forEach((tier) => {
        const tierElement = document.createElement("div");
        tierElement.className = "price-tier";
        tierElement.dataset.fromAmount = tier.from_amount;

        const discountedPrice = (
          variantPrice - tier.fixed_discount_amount
        ).toFixed(2);
        const grossPrice = (discountedPrice * 1.19).toFixed(2);

        // Calculate unit price for discounted tier keeping Shopify's original format
        let unitPriceText = "";
        if (variant.unit_price) {
          // Replicate the Liquid calculation: discounted_price * 100 * variant.unit_price / variant.price
          const discountedPriceInCents = discountedPrice * 100;
          const calculatedUnitPrice =
            (discountedPriceInCents * variant.unit_price) / variant.price;
          const calculatedUnitPriceFormatted = (calculatedUnitPrice / 100)
            .toFixed(2)
            .replace(".", ",");

          // Get the original Shopify formatted string and replace price part
          const originalFormat = priceLists.variantUnitMeasurements[variant.id];
          if (originalFormat) {
            const updatedFormat = originalFormat.replace(
              /€[\d,\.]+/,
              "€" + calculatedUnitPriceFormatted,
            );
            unitPriceText = `${updatedFormat}`;
          }
        }

        // Check if this tier has a compared_at_fixed_discount_amount (similar to Liquid logic)
        const hasComparedAtDiscount = tier.copmared_at_fixed_discount_amount;
        let mainPriceHTML = "";

        if (hasComparedAtDiscount) {
          const comparedAtDiscountedPrice = (
            variantPrice - tier.copmared_at_fixed_discount_amount
          ).toFixed(2);

          if (comparedAtDiscountedPrice > discountedPrice) {
            mainPriceHTML = `
                          <div class="price-amount-container">
                            <span class="price-amount price-amount-sale">${discountedPrice.replace(".", ",")} €*</span>
                            <span class="price-amount price-amount--old">${comparedAtDiscountedPrice.replace(".", ",")} €*</span>
                          </div>
                        `;
          } else {
            mainPriceHTML = `<span class="price-amount">${discountedPrice.replace(".", ",")} €*</span>`;
          }
        } else {
          mainPriceHTML = `<span class="price-amount">${discountedPrice.replace(".", ",")} €*</span>`;
        }

        tierElement.innerHTML = `
                  <div class="price-tier__content">
                    <div class="price-tier__quantity">
                      <span class="quantity-text">Ab ${tier.from_amount}</span>
                      <div class="base-price">
                        ${unitPriceText}
                      </div>
                    </div>
                    <div class="price-tier__pricing">
                      <div class="price-tier__pricing-container">
                        <div class="main-price">
                          ${mainPriceHTML}
                        </div>
                        <div class="gross-price">${grossPrice.toFixed(2).replace(".", ",")} € Brutto</div>
                      </div>
                    </div>
                  </div>
                `;

        // Insert before the disclaimer button if it exists, otherwise append to end
        if (disclaimerButton) {
          tiersContainer.insertBefore(tierElement, disclaimerButton);
        } else {
          tiersContainer.appendChild(tierElement);
        }
      });

      // Update active tier based on current quantity
      const quantityInput = document.querySelector("#Quantity-" + sectionId);
      const currentQuantity = parseInt(quantityInput?.value) || 1;
      updateActiveTierForModal(priceListContainer, currentQuantity, sectionId);

      // Also update the first tier (Ab 1) with the correct tax multiplier
      updateVariantPriceForModal(priceListContainer, variant);
    } catch (e) {
      console.error("Error updating price list for variant in modal:", e);
    }
  }
};
